import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// class Page extends React.Component {
const Page = ({ location }) => {
  const { pathname } = location;
  return (
    <div className="ul">
      <div className="li">
        <div className={`rect ${(pathname === '/') ? 'bg-red' : ''}`} />
        <Link to="/" href="/">OVERVIEW</Link>
      </div>
      <div className="li">
        <div className="rect" />
        <span>OPERATIONAL FOCUS</span>
      </div>
      <div className="ul2">
        <div className="li">
          <div className={`rect2 ${(pathname === '/hurricane-michael') ? 'bg-red' : ''}`} />
          <Link to="/hurricane-michael" href="/hurricane-florence">HURR. MICHAEL</Link>
        </div>
        <div className="li">
          <div className={`rect2 ${(pathname === '/hurricane-florence') ? 'bg-red' : ''}`} />
          <Link to="/hurricane-florence" href="/hurricane-florence">HURR. FLORENCE</Link>
        </div>
        <div className="li">
          <div className={`rect2 ${(pathname === '/hurricane-maria') ? 'bg-red' : ''}`} />
          <Link to="/hurricane-maria" href="/hurricane-maria">HURR. MARIA</Link>
        </div>
        <div className="li">
          <div className={`rect2 ${(pathname === '/hurricane-harvey') ? 'bg-red' : ''}`} />
          <Link to="/hurricane-harvey" href="/hurricane-harvey">HURR. HARVEY</Link>
        </div>
      </div>
      <div className="li">
        <div className={`rect ${(pathname === '/members') ? 'bg-red' : ''}`} />
        <Link to="/members" href="/members">MEMBERS</Link>
      </div>
      <div className="li">
        <div className={`rect ${(pathname === '/training') ? 'bg-red' : ''}`} />
        <Link to="/training" href="/training">TRAINING</Link>
      </div>
      <div className="li">
        <div className={`rect ${(pathname === '/operations') ? 'bg-red' : ''}`} />
        <Link to="/operations" href="/operations">OPERATIONS</Link>
      </div>
      <div className="li">
        <div className={`rect ${(pathname === '/work-orders') ? 'bg-red' : ''}`} />
        <Link to="/work-orders" href="/work-orders">WORK ORDERS</Link>
      </div>
      <div className="li">
        <div className={`rect ${(pathname === '/net-promoter-score') ? 'bg-red' : ''}`} />
        <Link to="/net-promoter-score" href="/net-promoter-score">NET PROMOTER SCORE</Link>
      </div>
      <div className="li">
        <div className={`rect ${(pathname === '/value') ? 'bg-red' : ''}`} />
        <Link to="/value" href="/value">VALUE</Link>
      </div>
      <div className="li">
        <div className={`rect ${(pathname === '/funding') ? 'bg-red' : ''}`} />
        <Link to="/funding" href="/funding">FUNDING</Link>
      </div>
    </div>
  );
};
Page.propTypes = {
  location: PropTypes.object,
};
Page.defaultProps = {
  location: {},
};

export default Page;
